import {
    FETCH_ALGORITHM, FETCH_ALGORITHM_SUCCESS, FETCH_ALGORITHM_FAILURE,
    SAVE_ALGORITHM, SAVE_ALGORITHM_SUCCESS, SAVE_ALGORITHM_FAILURE,
    EMPTY_ALGORITHM, SET_ALGORITHM
} from './constants';

const initialState = {
    config: {},
    defaultConfig: {},
    isFetching: false,
    isSaving: false,
    error: {}
};

function algorithmReducer(state = initialState, action) {
    switch(action.type) {
        case EMPTY_ALGORITHM:
            return initialState;
        case FETCH_ALGORITHM:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case FETCH_ALGORITHM_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                config: action.data.active,
                defaultConfig: action.data.default
            });
        case FETCH_ALGORITHM_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case SAVE_ALGORITHM:
            return Object.assign({}, state, {
                isSaving: true,
                error: {}
            });
        case SAVE_ALGORITHM_SUCCESS:
            return Object.assign({}, state, {
                isSaving: false,
                config: action.data
            });
        case SAVE_ALGORITHM_FAILURE:
            return Object.assign({}, state, {
                isSaving: false,
                error: action.error
            });
        case SET_ALGORITHM:
            return Object.assign({}, state, {
                config: action.data
            });
        default:
            return state;
    }
}

export default algorithmReducer;



// WEBPACK FOOTER //
// ./src/containers/AlgorithmPage/store/reducers.js